export enum ETextAlignment {
  CENTER = 'center',
  BLOCK = 'justify',
  START = 'start',
}
